export const OCCUPIED = "OCCUPIED"
export const PARTLY_OCCUPIED = "PARTLY_OCCUPIED"
export const AVAILABLE = "AVAILABLE"

export const availabilityTypes = [OCCUPIED, PARTLY_OCCUPIED, AVAILABLE]
